export default __webpack_public_path__ + "static/media/shipping-box.37055c86.svg";